var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7059 14.224C6.31795 14.8305 5.88013 15.4377 5.43744 16C2.22051 15.9025 1 13.6794 1 13.6794C1.04572 10.5295 1.76264 7.4317 3.09667 4.61978C4.26931 3.64301 5.69816 3.07858 7.18538 3.00464L7.62128 4.07676C8.24386 3.98473 8.87147 3.93667 9.5 3.93288C10.1313 3.93509 10.7618 3.98161 11.3874 4.07212L11.8233 3C13.312 3.07794 14.741 3.6473 15.9121 4.62906C17.2418 7.43894 17.9557 10.5333 18 13.6794C18 13.6794 16.7795 15.9025 13.5626 16C13.1194 15.4332 12.7034 14.843 12.3159 14.2317M15.1318 12.8858C13.4579 13.7887 11.8384 14.6912 9.5 14.6912C7.16163 14.6912 5.54205 13.7887 3.86821 12.8858",
    stroke: "currentColor",
    strokeWidth: 1.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11C7.32843 11 8 10.3284 8 9.5C8 8.67157 7.32843 8 6.5 8C5.67157 8 5 8.67157 5 9.5C5 10.3284 5.67157 11 6.5 11Z",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11C13.3284 11 14 10.3284 14 9.5C14 8.67157 13.3284 8 12.5 8C11.6716 8 11 8.67157 11 9.5C11 10.3284 11.6716 11 12.5 11Z",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscord);
export default __webpack_public_path__ + "static/media/icon-discord.96352f909c9b298209857fdee7b5f948.svg";
export { ForwardRef as ReactComponent };